
export default {
  props: ["data"],
};
